
export default {
  props: ["data"],
};
